export default "__VITE_ASSET__ed7b1543__"